module.exports = __webpack_public_path__ + "src/assets/img/girl_right_4.813092dd.png";